import { EMPTY_LIST } from '../../../../constants/common'

import { CalendarGridWeekHeadCell } from './CalendarGridWeekHeadCell'

import * as styles from './CalendarGridWeekHead.module.css'

function CalendarGridWeekHead({
  dayItemsByDay,
  dayLoads,
  days,
  outsideHoursItemsByDay,
  today,
  onClickItem,
  onClickSecondaryLabel,
}) {
  return (
    <>
      <div className={styles.corner} />
      {days.map(day => (
        <CalendarGridWeekHeadCell
          day={day}
          dayItems={dayItemsByDay[day.date] ?? EMPTY_LIST}
          dayLoad={dayLoads[day.date]}
          days={days}
          key={day.date}
          outsideHoursItems={outsideHoursItemsByDay[day.date]}
          today={today}
          onClickItem={onClickItem}
          onClickSecondaryLabel={onClickSecondaryLabel}
        />
      ))}
    </>
  )
}

export default CalendarGridWeekHead
